import { api } from "../ApiMapper/api";
import { toast } from "react-toastify";

export const fetchLogs = async (filters = {}) => {
  try {
    const response = await api.get('/api/logs', {
      params: {
        page: filters.page || 1,
        ...filters
      },
      headers: {
        'Accept': 'application/json'
      }
    });
    
    return {
      logs: response.data.data || [],
      pagination: response.data.pagination || {}
    };
  } catch (error) {
    console.error('Logs API Error:', error);
    throw error;
  }
};

export const addLog = async (log) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }
    const response = await api.post("/api/logs", log, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to add log';
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }
};
